module.exports = __webpack_public_path__ + "static/microsoft-surface-book-1251994b838ba0ed5de6774d99072463.png";